import { Action } from '@reduxjs/toolkit';

export const SIGNALR_CONNECTED = 'SIGNALR:CONNECTED';

export type SignalrConnected = Action<typeof SIGNALR_CONNECTED>;

export const signalrConnected = (): SignalrConnected => ({
  type: SIGNALR_CONNECTED,
});

// ---

export const SIGNALR_DISCONNECTED = 'SIGNALR:DISCONNECTED';

export type SignalrDisconnected = Action<typeof SIGNALR_DISCONNECTED>;

export const signalrDisconnected = (): SignalrDisconnected => ({
  type: SIGNALR_DISCONNECTED,
});
